// extracted by mini-css-extract-plugin
module.exports = {"container":"SampleInfo_container_5_cD3","containerGrid2":"SampleInfo_containerGrid2_3ytI-"};